import { SET_TAGS } from "../types/tagsTypes";

const initialState = {
  all: [],
};

const tagsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TAGS:
      return { ...state, all: action.payload };
    default:
      return state;
  }
};

export default tagsReducer;
